module.exports = __webpack_public_path__ + "static/media/logo.e5a5e488.png";